import { access } from '../constants';
import SignUp from '../pages/auth/SignUp';
import ResetPassword from '../pages/auth/ResetPassword';
import SignInPartner from '../pages/auth/SignInPartner';
import SignInJobcase from '../pages/auth/SignInJobcase';

const authRouteList = [
   {
      path: '/auth/login/pt',
      name: 'Sign In',
      component: SignInPartner,
      access: access.isPublic,
   },
   {
      path: '/auth/login/jobcase',
      name: 'Sign In',
      component: SignInJobcase,
      access: access.isPublic,
   },
   {
      path: '/auth/login/jobcase-intl',
      name: 'Sign In',
      component: SignInJobcase,
      access: access.isPublic,
   },
   {
      path: '/employer/auth/sign-up',
      name: 'Sign Up',
      component: SignUp,
      access: access.isPublic,
   },
   {
      path: '/employer/auth/reset-password',
      name: 'Reset Password',
      component: ResetPassword,
      access: access.isPublic,
   },
];

export default authRouteList;
